import Parse from 'parse'
import { findById } from '../../../../utils/db_functions'

const buildConsolidatedOrderCode = (orderCode, version) => {
  const baseCode = (orderCode || '').replace(/^PFM/, 'PCM')
  return `${baseCode}-${version}`
}

const toPlainJson = (value) => {
  if (value == null) return value
  if (typeof value.toJSON === 'function') return value.toJSON()
  if (value._isAMomentObject || (value.toISOString && value.toDate)) {
    return value.toISOString()
  }
  return JSON.parse(JSON.stringify(value))
}

const countExistingVersionsForOrder = async (orderId) => {
  const query = new Parse.Query('ConsolidatedOrder')
  const orderPointer = new (Parse.Object.extend('Order'))()
  orderPointer.id = orderId
  query.equalTo('orderRef', orderPointer)
  return query.count()
}

const buildOrderSnapshot = (order, proposalJson) => {
  const orderDate = order.get('order_date')
  return {
    order_code: order.get('order_code'),
    order_date: orderDate
      ? (orderDate.toISOString ? orderDate.toISOString() : orderDate)
      : null,
    total: order.get('total'),
    name_client: proposalJson.name_client || proposalJson.social_reason || '',
    social_reason: proposalJson.social_reason || '',
    name_work: proposalJson.name_work || '',
    city_work: proposalJson.city_work || '',
    proposal_code: proposalJson.proposal_code || '',
    clientContacts: toPlainJson(order.get('clientContacts') || proposalJson.clientContacts || []),
    workContacts: toPlainJson(order.get('workContacts') || proposalJson.workContacts || []),
  }
}

export const createConsolidatedOrderFromOrder = async (orderJson) => {
  const orderId = orderJson.objectId || orderJson.id
  if (!orderId) {
    throw new Error('Pedido inválido para consolidação')
  }

  const order = await findById('Order', orderId, ['proposalRef'])
  if (!order || !order.get('order_code')) {
    throw new Error('Pedido não encontrado ou sem código')
  }

  const existingCount = await countExistingVersionsForOrder(orderId)
  const version = existingCount + 1
  const code = buildConsolidatedOrderCode(order.get('order_code'), version)

  const proposalRef = order.get('proposalRef')
  let proposalJson = {}
  let product_blocks = []

  if (proposalRef) {
    const proposal = await findById('Proposal', proposalRef.id || proposalRef.objectId)
    if (proposal) {
      proposalJson = proposal.toJSON()
      product_blocks = toPlainJson(proposal.get('product_blocks') || [])
    }
  }

  if (!product_blocks.length && order.get('proposal')) {
    const proposalSnapshot =
      typeof order.get('proposal') === 'string'
        ? JSON.parse(order.get('proposal'))
        : order.get('proposal')
    proposalJson = proposalSnapshot || {}
    product_blocks = toPlainJson((proposalSnapshot && proposalSnapshot.product_blocks) || [])
  }

  const ConsolidatedOrder = Parse.Object.extend('ConsolidatedOrder')
  const consolidatedOrder = new ConsolidatedOrder()
  consolidatedOrder.set('code', code)
  consolidatedOrder.set('version', version)
  consolidatedOrder.set('order_code', order.get('order_code'))
  consolidatedOrder.set('orderRef', order)
  consolidatedOrder.set('product_blocks', product_blocks)
  consolidatedOrder.set('order_snapshot', buildOrderSnapshot(order, proposalJson))

  if (proposalRef) {
    consolidatedOrder.set('proposalRef', proposalRef)
  }

  if (Parse.User.current()) {
    consolidatedOrder.set('updatedBy', Parse.User.current())
  }

  try {
    return await consolidatedOrder.save()
  } catch (error) {
    throw new Error(
      (error && (error.message || error.error)) ||
        'Não foi possível criar o pedido consolidado'
    )
  }
}

export { buildConsolidatedOrderCode }
